module.exports = __webpack_public_path__ + "static/media/pointToolInactive.fc286e36.png";